import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  efimeroFoldersIds: [],
  folders: [],
  signed: [],
  unsigned: [],
  signedLastId: false,
  unSignedLastId: false,
  signedFilters: {},
  unsignedFilters: {},
  documents: [],
  documentsTotalUnsigned: 0,
  document: {},
  imageValue: '',
  loading: false,
  file: '',
  page: 1,
  totalPages: 0,
  requestedList: false
}

const DocumentsModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default DocumentsModule
